module.exports = __webpack_public_path__ + "static/media/paper_plane_512.7c7263b8.png";